import who from "../assets/png/who.png"

export const aboutData = {
  title: "Welcome to My World of Web and Mobile Development Excellence ✌😎",
  description1: `React developer with a specialization in creating highly responsive user interfaces based on 
design mockups, utilizing tools like Figma or Adobe XD. My skill set includes a strong proficiency 
in localizations and a deep understanding of web sockets, allowing me to implement real-time
communication effectively. With a solid grasp of agile development practices, I consistently 
deliver websites that not only meet but exceed client expectations. My core strengths in 
JavaScript and React, enabling me to build dynamic and engaging web experiences. Additionally, I 
bring valuable experience working with Node.js and MQTT for real-time communication and IoT 
integration, making me a versatile Front End Developer capable of tackling a wide range of 
projects`,
  description2: "",
  image: who,
};